export const voucherStatus = {
  valid: 'valid',
  invalid: 'invalid',
}
